import { NextSeo } from 'next-seo';
import { FC, Fragment } from 'react';

import { JsonLd } from '@/components/ui/shared/seo/JsonLd/JsonLd';
import { buildBreadcrumbSchema, buildWebPageSchema, getAbsoluteUrl } from '@/utils/structured-data';

const PAGE_PATH = 'librarians';
const PAGE_TITLE = 'A digital library of groundbreaking research';
const PAGE_DESCRIPTION =
  'More than 80,000 curated and aggregated videos of lectures and presentations from top scientific and medical conferences. Multidisciplinary coverage of physical, material and health sciences, social sciences, and humanities.';

export const LibrariansSeo: FC = () => {
  return (
    <Fragment>
      <NextSeo
        title={PAGE_TITLE}
        description={PAGE_DESCRIPTION}
        canonical={getAbsoluteUrl(PAGE_PATH)}
        openGraph={{
          url: getAbsoluteUrl(PAGE_PATH),
          title: PAGE_TITLE,
          description: PAGE_DESCRIPTION,
        }}
      />
      <JsonLd
        id="librarians"
        schema={[
          buildWebPageSchema({ path: PAGE_PATH, name: PAGE_TITLE, description: PAGE_DESCRIPTION }),
          buildBreadcrumbSchema([
            { name: 'Home', path: '' },
            { name: 'Librarians', path: PAGE_PATH },
          ]),
        ]}
      />
    </Fragment>
  );
};
